module.exports = __webpack_public_path__ + "img/PreLoad_ofm.1a393ce.gif";